import { render, staticRenderFns } from "./NxHero.vue?vue&type=template&id=19c89a82&scoped=true"
import script from "./NxHero.vue?vue&type=script&lang=js"
export * from "./NxHero.vue?vue&type=script&lang=js"
import style0 from "./NxHero.vue?vue&type=style&index=0&id=19c89a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c89a82",
  null
  
)

export default component.exports